import { render, staticRenderFns } from "./AwaitingEvaluation.vue?vue&type=template&id=2b87ceae&"
import script from "./AwaitingEvaluation.vue?vue&type=script&lang=js&"
export * from "./AwaitingEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./AwaitingEvaluation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports